import React, { Component } from "react";
import { connect } from "react-redux";
import ImageDiv from "./ImageDiv";
import MainText from "./MainText";
import ToolBar from "./Toolbar";
import Subpage from './Subpage';
class ChooseNextPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chosen: false,
    };
  }
  // chose which prototype you want to explore, which then will load up a certain view.
  // to do: create a component with this subpage view and just render whichever one is chosen
  // include an option to return to this choose page or just proceed to next part of the lesson

  reset = () => {
      this.setState({
          ...this.state,
          chosen: false
      })
  }
  selectPrototype = (prototype) => {
    this.setState({
      chosen: true
    });
    this.props.dispatch({type: 'SET_PROTOTYPE', payload: prototype.order})
  };
  render() {
    return (
      <div className="layout-page">
        {!this.state.chosen && 
          <div className="flex-box flex-center">
            <div className="column-lg-10 column-sm-12 col-md-12">
              {this.props.activeScene.title !== null && (
                <h2><span className="title">{this.props.activeScene.title}</span></h2>
              )}
            </div>
          </div>}
          {!this.state.chosen &&<div className="flex-box">
          {this.props.activeScene.text.length > 0 && (
            <div className="flex-box column-lg-10 column-sm-12 column-md-12">
              {this.props.activeScene.text.map((text, i) => {
                return <MainText className={`text-div`} text={text} key={i} />;
              })}
            </div>
          )}
            </div>}
       
          {!this.state.chosen ? (
            <div className="flex-box flex-evenly">
              {this.props.activeScene.images.map((image, i) => {
                return (
                  <div className="column-lg-3 column-sm-12 column-md-12">
                    <h3
                      className="link link-dark"
                      onClick={() => this.selectPrototype(image)}
                    >
                      Explore {image.alt} &rarr;
                    </h3>
                    <ImageDiv
                      class={`chooseOne`}
                      columns={`column-lg-12 column-sm-12 column-md-12`}
                      image={image}
                      key={i}
                    />
                  </div>
                );
              })}
            </div>
          ) : (
            <Subpage back={this.reset} content={this.props.prototypes}/>
          )}
      

       {!this.state.chosen && <ToolBar history={this.props.history} />} 
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  activeScene: state.activeScene,
  prototypes: state.prototypes
});
export default connect(mapStateToProps)(ChooseNextPage);
